"use client";

import { useIsAgent } from "hooks/useIsAgent";
const AgentCommissionNotice = ({
  className = ""
}: {
  className?: string;
}) => {
  const isAgent = useIsAgent();
  if (!isAgent) return null;
  return <div className={`mt-4 flex justify-center ${className}`} data-sentry-component="AgentCommissionNotice" data-sentry-source-file="AgentCommissionNotice.tsx">
      <div className='rounded-2xl bg-Gray-200 px-2 py-1'>
        <span className='text-xs font-medium leading-3 text-Gray-700'>
          Your clients won&rsquo;t see any commission details
        </span>
      </div>
    </div>;
};
export default AgentCommissionNotice;